import { render, staticRenderFns } from "./ControlRecords.vue?vue&type=template&id=135df80c&"
import script from "./ControlRecords.vue?vue&type=script&lang=js&"
export * from "./ControlRecords.vue?vue&type=script&lang=js&"
import style0 from "./ControlRecords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports